import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/atoms/card';
import { Input } from '@/components/atoms/input';
import {
  FormField,
  FormItem,
  FormControl,
  FormMessage,
  FormDescription,
} from '@/components/molecules/form-field';
import type { CreateProductFormData, UpdateProductFormData } from '../types/product-form.types';

interface ProductTagsProps<T extends CreateProductFormData | UpdateProductFormData> {
  form: UseFormReturn<T>;
}

export function ProductTags<T extends CreateProductFormData | UpdateProductFormData>({
  form,
}: ProductTagsProps<T>) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('products.tags')}</CardTitle>
      </CardHeader>
      <CardContent>
        <FormField
          control={form.control}
          name={'tags' as any}
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input placeholder={t('products.tagsPlaceholder')} {...field} />
              </FormControl>
              <FormDescription>{t('products.tagsHint')}</FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
}
